import { useSyncExternalStore } from 'react';
import german from './locales/de.json';
import { saveLanguagePreference } from './languagePreference';
const listeners = new Set();
const cache = { de: german };
let language = 'de';
let dictionary = german;
let requestVersion = 0;
const subscribe = callback => { listeners.add(callback); return () => listeners.delete(callback); };
export const getLanguage = () => language;
export function t(value, variables = {}) {
  if (typeof value !== 'string') return value;
  const translated = dictionary[value] || value;
  return translated.replace(/\{(\w+)\}/g, (match, key) => Object.prototype.hasOwnProperty.call(variables, key) ? String(variables[key]) : match);
}
export async function setLanguage(next, { persist = true } = {}) {
  if (!['de', 'en', 'es'].includes(next)) return;
  const version = ++requestVersion;
  if (!cache[next]) {
    const response = await fetch('/locales/' + next + '.json', { cache: 'no-cache' });
    if (!response.ok) throw new Error('Language file unavailable');
    cache[next] = await response.json();
  }
  if (version !== requestVersion) return;
  dictionary = cache[next]; language = next;
  if (persist) saveLanguagePreference(next);
  document.documentElement.lang = next;
  listeners.forEach(callback => callback());
}
export function useLanguage() {
  const locale = useSyncExternalStore(subscribe, getLanguage, () => 'de');
  return { language: locale, t, setLanguage };
}
export function translateMarkup(markup, locale = language) {
  const activeDictionary = cache[locale] || dictionary;
  const document = new DOMParser().parseFromString(markup, 'text/html');
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    const node = walker.currentNode, original = node.nodeValue, key = original.trim();
    if (activeDictionary[key]) node.nodeValue = original.replace(key, activeDictionary[key]);
  }
  document.querySelectorAll('[alt], [aria-label], [title]').forEach(element => {
    for (const name of ['alt', 'aria-label', 'title']) if (element.hasAttribute(name)) element.setAttribute(name, t(element.getAttribute(name)));
  });
  document.querySelectorAll('a[href]').forEach(anchor => {
    const href = anchor.getAttribute('href');
    if (href === 'https://www.jaragency.de/datenschutz/') anchor.href = '/datenschutz';
    if (href.startsWith('mailto:') && href.includes('subject=')) {
      const url = new URL(href);
      url.searchParams.set('subject', {de:'Scene Share XR — Demoanfrage',en:'Scene Share XR — Demo request',es:'Scene Share XR — Solicitud de demo'}[locale]);
      url.searchParams.set('body', {de:'Name: \nUnternehmen: \nProjekt / Wunsch: ',en:'Name: \nCompany: \nProject / request: ',es:'Nombre: \nEmpresa: \nProyecto / solicitud: '}[locale]);
      anchor.href = url.href;
    }
  });
  return document.body.innerHTML;
}
